export default function (lovIdentifier) {
  // can return array of object like { identifier: 'data', name: 'Addition data', readonly: true }
  return []
}
